export enum Variants {
  rectangle = 'rectangle',
  rounded = 'rounded',
  circle = 'circle',
  text = 'text',
}
